import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import AdminLayout from "@/components/AdminLayout";
import { useI18n } from "@/contexts/I18nContext";
import { useAuth } from "@/contexts/AuthContext";
import { Store, Boxes, ShoppingBag, ExternalLink, ArrowRight } from "lucide-react";

export default function RivenditoreDashboard() {
  const { t } = useI18n();
  const { user } = useAuth();
  const [catalog, setCatalog] = useState([]);
  const [orders, setOrders] = useState([]);
  const [tenant, setTenant] = useState(null);

  useEffect(() => {
    api.get("/catalog").then((r) => setCatalog(r.data));
    api.get("/orders").then((r) => setOrders(r.data));
    if (user.tenant_id) api.get(`/tenants/${user.tenant_id}`).then((r) => setTenant(r.data));
  }, [user.tenant_id]);

  const visible = catalog.filter((c) => c.visibile_in_vetrina).length;

  return (
    <AdminLayout>
      <div className="p-8 lg:p-10" data-testid="riv-dashboard">
        <div className="flex items-end justify-between mb-10">
          <div>
            <div className="overline text-brand mb-2">Rivenditore · {tenant?.name}</div>
            <h1 className="font-heading font-bold text-4xl tracking-tight">{t("riv_dashboard")}</h1>
          </div>
          {tenant && (
            <a
              href={`/s/${tenant.slug}`}
              target="_blank" rel="noreferrer"
              data-testid="riv-view-storefront-btn"
              className="text-sm px-4 h-10 inline-flex items-center gap-1.5 rounded-sm border border-foreground text-foreground hover:bg-foreground hover:text-white transition-colors"
            >
              {t("riv_view_storefront")} <ExternalLink className="w-4 h-4" />
            </a>
          )}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-border border border-border rounded-sm overflow-hidden mb-10">
          <div className="bg-white p-6" data-testid="riv-stat-catalog">
            <Boxes className="w-5 h-5 text-brand mb-3" strokeWidth={1.5} />
            <div className="text-4xl font-heading font-bold leading-none">{catalog.length}</div>
            <div className="text-xs text-muted-foreground mt-2">Articoli nel catalogo</div>
          </div>
          <div className="bg-white p-6" data-testid="riv-stat-visible">
            <Store className="w-5 h-5 text-brand mb-3" strokeWidth={1.5} />
            <div className="text-4xl font-heading font-bold leading-none">{visible}</div>
            <div className="text-xs text-muted-foreground mt-2">Visibili in vetrina</div>
          </div>
          <div className="bg-white p-6" data-testid="riv-stat-orders">
            <ShoppingBag className="w-5 h-5 text-brand mb-3" strokeWidth={1.5} />
            <div className="text-4xl font-heading font-bold leading-none">{orders.length}</div>
            <div className="text-xs text-muted-foreground mt-2">Ordini B2C</div>
          </div>
        </div>

        <Link to="/rivenditore/catalog" data-testid="riv-link-catalog" className="admin-card p-6 group block max-w-2xl">
          <div className="overline text-brand mb-2">Modulo</div>
          <h3 className="font-heading font-bold text-2xl mb-2">{t("riv_catalog")}</h3>
          <p className="text-sm text-muted-foreground mb-4">Attiva/disattiva articoli in vetrina, regola prezzi e sconti per ogni variante.</p>
          <span className="text-brand text-sm inline-flex items-center gap-1.5 group-hover:gap-2.5 transition-all">Apri <ArrowRight className="w-4 h-4" /></span>
        </Link>
      </div>
    </AdminLayout>
  );
}
